// index.ts
import { CRUDL, installExtension } from "@juitnow/lib-fetch-client";
export * from "../types/validators.mjs";
var PaymentsImpl = class {
  _crudl;
  constructor(http) {
    this._crudl = new CRUDL(http, "/payments/v1");
  }
  async createOneoff(body) {
    const response = await this._crudl.http.post("/payments/v1/oneoff", body);
    return response.data;
  }
  read(uuid) {
    return this._crudl.read(uuid);
  }
  list(query) {
    return this._crudl.list({ ...query });
  }
  async methods(query) {
    let path = "/payments/v1/methods";
    if (query) path += `?order_type=${query.order_type}`;
    const response = await this._crudl.http.get(path);
    return response.data;
  }
  async refund(uuid, amount) {
    const response = await this._crudl.http.post(`/payments/v1/${uuid}/refund`, { amount_cents: amount });
    return response.data;
  }
};
var MandatesImpl = class {
  _crudl;
  constructor(http) {
    this._crudl = new CRUDL(http, "/payments/v1/mandates");
  }
  async read(uuid) {
    return this._crudl.read(uuid);
  }
  async list(query) {
    return this._crudl.list({ ...query });
  }
  async delete(uuid) {
    return this._crudl.delete(uuid);
  }
};
installExtension("payments", PaymentsImpl);
installExtension("mandates", MandatesImpl);
export {
  MandatesImpl,
  PaymentsImpl
};
//# sourceMappingURL=index.mjs.map
